import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Automotive, BusinessProcessingOutsource, Careers, FashionApparel, FoodHospitality, Footer, HomePage, ImportExport, InteriorDesign, Philanthropy, RealEstate, SellYourBusiness, Telecommunication, WhatsNew } from './containers';
import { Brand, Navbar, Privacy } from './components';
import Investors from './components/investors/investors';

import './App.css';

const App = () => {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement;
      const maxScroll = doc.scrollHeight - window.innerHeight;
      const scrollRatio = maxScroll > 0 ? window.scrollY / maxScroll : 0;
      setShowBackToTop(scrollRatio >= 0.6);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <BrowserRouter>
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/investor" element={<Navigate to="/investors" replace />} />
            <Route path="/investors" element={<Investors />} />
            <Route path="/Brand" element={<Brand />} />
            <Route path="/portfolio" element={<Brand />} />
            <Route path="/portfolio/telecommunication" element={<Telecommunication />} />
            <Route path="/portfolio/real-estate" element={<RealEstate />} />
            <Route path="/portfolio/interior-design" element={<InteriorDesign />} />
            <Route path="/portfolio/bpo" element={<BusinessProcessingOutsource />} />
            <Route path="/portfolio/food-hospitality" element={<FoodHospitality />} />
            <Route path="/portfolio/import-export" element={<ImportExport />} />
            <Route path="/portfolio/automotive" element={<Automotive />} />
            <Route path="/portfolio/fashion-apparel" element={<FashionApparel />} />
            <Route path="/portfolio/philanthropy" element={<Philanthropy />} />
            <Route path="/portfolio/:industry" element={<Brand />} />
            <Route path="/sell-your-business" element={<SellYourBusiness />} />
            <Route path="/whats-new" element={<WhatsNew />} />
            <Route path="/careers" element={<Careers />} />
          </Routes>
        </main>
        {showBackToTop && (
          <button
            type="button"
            className="kw__back-to-top"
            onClick={handleBackToTop}
            aria-label="Back to top"
          >
            ↑
          </button>
        )}
        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default App;
